var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunityMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 98.5 98.5",
    style: {
      enableBackground: "new 0 0 98.5 98.5"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\r\n\t.st0{fill:#EA0070;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    style: {
      fill: "#14a9a3",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g24",
    style: {
      fill: "#14a9a3",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71,81.4l0.2-0.3L70.9,81c-1.3-0.5-2.5-1.2-3.5-2.1l-0.2-0.2L67,79c-1.6,2.5-4,4.3-6.9,4.7l0,0    c-0.4,0.1-0.8,0.1-1.2,0.1c-2.5,0-4.8-1-6.7-2.7l-0.2-0.2l-0.2,0.2c-1.6,2.5-4,4.3-6.9,4.7c-0.4,0.1-0.8,0.1-1.3,0.1    c-2.5,0-4.8-1-6.7-2.7L36.6,83l-0.2,0.2c-0.8,1.2-1.7,2.2-2.9,3.1l-0.3,0.2l0.3,0.2c3.8,2.5,8.6,4.2,14.7,4.2    c1.5,0,3.2-0.1,4.9-0.3l0,0h0C61.8,89.4,67.4,85.8,71,81.4z",
    id: "path4",
    style: {
      fill: "#14a9a3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.5,74.4c-0.1,0.1-0.2,0.1-0.2,0.1c-0.4,0-0.8,0-1.3,0c-2.5,0-4.8-1.1-6.7-2.8l-0.2-0.2L66,71.7    c-1.6,2.5-4,4.3-6.9,4.7c-0.4,0.1-0.8,0.1-1.2,0.1c-2.5,0-4.8-1-6.7-2.7l-0.2-0.2l-0.2,0.2c-1.6,2.5-4,4.3-6.9,4.7    c-0.4,0.1-0.8,0.1-1.3,0.1c-2.5,0-4.8-1-6.7-2.7l-0.2-0.2l-0.2,0.2c-0.8,1.3-1.8,2.5-3,3.3c-1.1,0.9-2.4,1.4-3.9,1.4h0h0    c0,0-0.2,0-0.5,0c-0.3,0-0.6,0-0.8,0h-0.5l0.3,0.4c1.2,1.5,3,3.3,4,4.4v0.3l0.4-0.2c2.1-0.9,3-2.2,4-3.7l0,0l0.6-1.1l0.8,0.7l0,0    c1.9,2,4.3,3.1,6.7,3.1l0,0h0h0c0.4,0,0.7,0,1.1-0.1c2.8-0.4,5.1-2.3,6.5-5l0.4-0.8l0.6,0.7l0,0c1.9,2,4.2,3.1,6.6,3.1l0,0h0h0    c0.4,0,0.7,0,1.1-0.1c2.8-0.4,5.1-2.3,6.5-5l0.4-0.8l0.6,0.7c1.3,1.4,2.8,2.3,4.4,2.8l0.2,0.1l0.1-0.1c1.3-1.8,2.3-3.5,3-5.3    l0.2-0.4l-0.5,0.1C74.8,74.2,74.6,74.3,74.5,74.4z",
    id: "path6",
    style: {
      fill: "#14a9a3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.3,66.8l0,0.2L73.3,66.8c-0.4,0.1-0.8,0.1-1.3,0.1c-2.5,0-4.8-1-6.7-2.7L65.1,64l-0.2,0.2    c-1.6,2.5-4,4.3-6.9,4.7c-0.4,0.1-0.8,0.1-1.2,0.1c-2.5,0-4.8-1-6.7-2.7l-0.2-0.2l-0.2,0.2c-1.6,2.5-4,4.3-6.9,4.7    c-0.4,0.1-0.8,0.1-1.3,0.1c-2.5,0-4.8-1-6.7-2.7l-0.2-0.2l-0.2,0.2c-1.6,2.5-4,4.3-6.9,4.7c-0.4,0.1-0.8,0.1-1.2,0.1    c-1,0-2-0.2-3-0.5l-0.5-0.2l0.2,0.5c0.8,1.9,1.8,3.8,3.2,6l0,0l0.1,0.1l0.1,0l0.1,0c0.3,0,0.5,0,0.8,0c0.4,0,0.7,0,1.1-0.1h0l0,0    c2.8-0.4,5.1-2.3,6.5-5l0.4-0.8l0.6,0.7c1.9,2,4.2,3.1,6.6,3.1l0,0h0h0c0.4,0,0.7,0,1.1-0.1c2.8-0.4,5.1-2.3,6.5-5l0.4-0.8    l0.6,0.7c1.9,2,4.2,3.1,6.6,3.1l0,0h0h0c0.4,0,0.7,0,1.1-0.1c2.8-0.4,5.1-2.3,6.5-5l0.4-0.8l0.6,0.7c1.9,2,4.3,2.8,6.6,2.9    c0.2,0,0.4,0,0.6,0c1.3,0,2.1-0.2,2.1-0.2l0.1,0l0-0.1c0.8-2.5,1.3-4.9,1.5-6.9l0.1-0.5l-0.5,0.3C75.9,66.1,74.7,66.7,73.3,66.8z",
    id: "path8",
    style: {
      fill: "#14a9a3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.7,59.8L69.4,0l-9.8,14.8l-16.8,2.5L26,19.6L12.5,8.1l8.6,59.7l0,0c0,0,0.1,0.6,0.3,1.3    c0.1,0.3,0.2,0.7,0.3,1c0.1,0.3,0.2,0.6,0.4,0.8l0,0l0,0c1.3,0.7,2.7,1.1,4.1,1.1c0.4,0,0.7,0,1.1-0.1l0-0.3l0,0.2    c2.8-0.4,5.1-2.3,6.5-5l0.4-0.8l0.6,0.7c1.9,2,4.2,3.1,6.6,3.1l0,0h0l0,0h0c0.4,0,0.7,0,1.1-0.1c2.8-0.4,5.1-2.3,6.5-5l0,0    l0.4-0.8l0.6,0.7c1.9,2,4.2,3.1,6.6,3.1l0,0l0,0h0h0c0.3,0,0.7,0,1.1-0.1c2.8-0.4,5.1-2.3,6.5-5l0.4-0.8l0.6,0.7    c1.9,2,4.2,3.1,6.6,3.1l0,0h0c0.3,0,0.7,0,1.1-0.1c3-0.6,4.5-2.2,4.5-2.2l0.1-0.1l0-0.1c0.1-0.4,0.1-1,0.1-1.5    C77.8,60.7,77.7,59.8,77.7,59.8L77.7,59.8L77.7,59.8L77.7,59.8z M21.6,39.9c0-5.6,4.1-10.5,9.8-11.3c0.5-0.1,1.1-0.1,1.6-0.1    c5.6,0,10.5,4.1,11.3,9.8c0.1,0.5,0.1,1.1,0.1,1.6c0,5.6-4.1,10.5-9.8,11.3c-0.5,0.1-1.1,0.1-1.6,0.1c-5.6,0-10.5-4.1-11.3-9.8    C21.6,40.9,21.6,40.4,21.6,39.9z M21.7,20.1l-4.2,0.6l-0.7-5L21.7,20.1z M46.8,45.7c0.1,0,0.2,0,0.3,0c1.1,0,2.1,0.8,2.3,2l0,0    l0.3,2.5c0,0.1,0,0.1,0,0.2c0,0.3-0.1,0.8-0.3,1.4c-0.2,0.8-0.6,1.8-0.9,2.5c-0.2,0.4-0.3,0.7-0.4,0.9c0,0,0,0,0,0    c-0.3-0.4-0.9-1.1-1.5-1.8c-0.3-0.4-0.7-0.9-0.9-1.3c-0.3-0.4-0.4-0.8-0.5-1.1l0,0C45.1,50,45,49.4,45,49c0-0.2,0-0.4,0-0.5    c0-0.1,0-0.2,0-0.2v0l0,0c0-0.1,0-0.2,0-0.3C44.9,46.9,45.7,45.9,46.8,45.7l0-0.2L46.8,45.7z M56.9,24.9c0.5-0.1,1.1-0.1,1.6-0.1    c5.6,0,10.5,4.1,11.3,9.8c0.1,0.5,0.1,1.1,0.1,1.6c0,5.6-4.1,10.5-9.8,11.3c-0.5,0.1-1.1,0.1-1.6,0.1c-5.6,0-10.5-4.1-11.3-9.8    c-0.1-0.5-0.1-1.1-0.1-1.6C47.1,30.6,51.2,25.8,56.9,24.9L56.9,24.9z M67.2,8.5l0.7,5l-4.2,0.6L67.2,8.5z",
    id: "path10",
    style: {
      fill: "#14a9a3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.7,93.7c0,0-0.1-0.7-0.7-1.5c-0.3-0.4-0.6-0.7-1.1-1c-0.5-0.3-1.1-0.5-1.8-0.5c-0.2,0-0.4,0-0.6,0h0h0    l0,0.2l0-0.2c-1.4,0.2-2.3,1-2.7,1.8c-0.4,0.8-0.5,1.6-0.5,2c0,0.1,0,0.2,0,0.2v0l0.5,3.7l1.7-2l2,1.4L41,96l2.2,1.5L42.7,93.7    C42.7,93.8,42.7,93.7,42.7,93.7z",
    id: "path12",
    style: {
      fill: "#14a9a3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.4,89.7c0,0-0.1-0.7-0.7-1.5c-0.3-0.4-0.6-0.7-1.1-1c-0.5-0.3-1.1-0.5-1.8-0.5c-0.2,0-0.4,0-0.6,0h0l0,0    c-1.4,0.2-2.3,1-2.7,1.8c-0.4,0.8-0.5,1.6-0.5,2c0,0.1,0,0.2,0,0.2v0l0.5,3.7l1.7-2l2,1.4l1.5-1.9l2.2,1.5L71.4,89.7L71.4,89.7    L71.4,89.7z",
    id: "path14",
    style: {
      fill: "#14a9a3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.5,40.5c0.3,2.3,2.3,3.9,4.5,3.9c0.2,0,0.4,0,0.6,0c2.3-0.3,3.9-2.3,3.9-4.5c0-0.2,0-0.4,0-0.6    c-0.3-2.3-2.3-3.9-4.5-3.9c-0.2,0-0.4,0-0.6,0c-2.3,0.3-3.9,2.3-3.9,4.5C28.5,40.1,28.5,40.3,28.5,40.5L28.5,40.5z",
    id: "path16",
    style: {
      fill: "#14a9a3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.5,40.8c0.2,0,0.4,0,0.6,0c2.3-0.3,3.9-2.3,3.9-4.5c0-0.2,0-0.4,0-0.6c-0.3-2.3-2.3-3.9-4.5-3.9    c-0.2,0-0.4,0-0.6,0C55.6,32.1,54,34,54,36.2c0,0.2,0,0.4,0,0.6C54.3,39.1,56.3,40.8,58.5,40.8z",
    id: "path18",
    style: {
      fill: "#14a9a3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.3,58c0,0-0.5-3.4-2.1-7.4c-1.6-4.1-4.4-8.9-9.1-11.9l-0.5-0.3l0.1,0.6l1.4,8.7l0,0c0,0,3.2,6.7,9.8,10.7    l0.4,0.3L87.3,58z",
    id: "path20",
    style: {
      fill: "#14a9a3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,47c-4.8,5.5-5.6,13.2-5.6,17.8c0,2.4,0.2,4,0.2,4l0.1,0.5l0.4-0.4c5.3-5.7,6.5-13,6.5-13l0,0l-1.2-9.3    L16.8,47z",
    id: "path22",
    style: {
      fill: "#14a9a3",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityMobile);
export default __webpack_public_path__ + "static/media/community-mobile.c6a6f113169958b6fc252ddbd6aa775c.svg";
export { ForwardRef as ReactComponent };